export const listTableOption = {
  page:false,
  border: true,
  stripe: true,
  align:'center',
  menuAlign:'center',
  refreshBtn: false,
  delBtn: false,
  editBtn: false,
  addBtn: false,
  searchShow: false,
  searchBtn: false,
  column: [{
    label: '应用标题',
    width: 200,
    prop: 'title',
    overHidden: true,
    align: 'left'
  },{
    label: '描述',
    prop: 'description',
    align: 'left',
    overHidden: true,
    width: 200,
  }, {
    label: '展示图',
    width: 200,
    prop: 'coverUrl',
    solt: true,
    align: 'left'
  }, {
    label: '链接',
    width: 200,
    prop: 'path',
    solt: true,
    align: 'left',
  },{
    label: '分组',
    prop: 'groupName',
    align: 'left',
    width: 200,
  }, {
    label: '排序',
    prop: 'sort',
    align: 'left',
    width: 100,
  }, {
    label: '状态',
    prop: 'isBanned',
    align: 'left',
    solt: true,
    width: 100,
  }]
}
